<script lang="ts">
  import type { ColumnDef } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiCheckCircleOutline, mdiPencilOutline, mdiLockOutline } from "@mdi/js"
  import type { OrderTypeRow } from "../../_shared/_logic/table-model"

  type Props = {
    row: OrderTypeRow
    column: ColumnDef
  }

  let { row, column }: Props = $props()

  const cellValue = $derived(String((row as Record<string, unknown>)[column.id] ?? ""))
  const isStandardType = $derived(Boolean(row.orderType.is_standard_type))
  const typeTooltip = $derived(
    row.orderType.is_protected
      ? "Wird für die Auftragstyp-Vorauswahl benötigt. Bezeichnung, Beschreibung und Dauer können bearbeitet werden; Löschen ist nicht möglich."
      : isStandardType
        ? "Standardtyp für generische Klebezettel."
        : "Eigener Auftragstyp dieser Organisation.",
  )
</script>

{#if column.id === "typeLabel"}
  <StatusTag
    variant="neutral"
    label={row.publicLabel}
    subLabel={row.internalLabel}
    color="neutral"
    icon={row.orderType.is_protected
      ? mdiLockOutline
      : isStandardType
        ? mdiCheckCircleOutline
        : mdiPencilOutline}
    tooltipContent={typeTooltip}
  />
{:else if column.id === "description"}
  <div class="description-cell">{row.description}</div>
{:else}
  {cellValue}
{/if}

<style lang="less">
  @import "@kontextwerk/web-sdk/theme/tokens.less";

  .description-cell {
    max-width: 300px;
    color: var(--text-invers-80);
    font-size: 0.9rem;
    line-height: 1.35;
    white-space: normal;
  }
</style>
